import { render, staticRenderFns } from "./Pend.vue?vue&type=template&id=fdfdacce&"
import script from "./Pend.vue?vue&type=script&lang=ts&"
export * from "./Pend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports